import { useReferralSourceImportStore } from 'stores/referralSourceImportStore';

import ReferralSourceImportTracker from './ReferralSourceImportTracker';

// Mounted once at the app root, next to AIJobNotificationManager.
export default function ReferralSourceImportManager() {
  const trackedImports = useReferralSourceImportStore((state) => state.trackedImports);
  const untrackImport = useReferralSourceImportStore((state) => state.untrackImport);

  return (
    <>
      {trackedImports.map((referralSourceImport) => (
        <ReferralSourceImportTracker
          key={referralSourceImport.id}
          referralSourceImport={referralSourceImport}
          onSettled={untrackImport}
        />
      ))}
    </>
  );
}
